import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/img/logo.png'
import _imports_1 from '@/assets/svg/menu.svg'
import _imports_2 from '@/assets/svg/close.svg'


const _hoisted_1 = { class: "w-full px-6 py-4 md:px-0 bg-play-gray" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "#main-content",
  class: "transition left-0 bg-white absolute p-3 m-3 -translate-y-16 focus:translate-y-0"
}, "Skip to Content", -1)
const _hoisted_3 = { class: "container mx-auto" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", { href: "/dashboard" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Play Included Home",
    class: "w-20 h-12 md:h-[107px] md:w-auto"
  })
], -1)
const _hoisted_6 = { class: "flex items-center space-x-4 md:items-start" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "text-xl underline" }
const _hoisted_9 = {
  key: 0,
  src: _imports_1,
  class: "text-black"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_2,
  class: "text-black"
}

import { useGlobalStore } from "@/store";
import { storeToRefs } from "pinia";

import LanguageSwitcher from "./LanguageSwitcher.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationBar',
  setup(__props) {

const globalStore = useGlobalStore();

const website_url = process.env.VUE_APP_WEBSITE_URL;

const { toggleMobileMenu } = globalStore;
const { isMobileMenuOpen } = storeToRefs(globalStore);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(LanguageSwitcher),
          _createElementVNode("a", {
            href: _unref(website_url),
            class: "hidden font-medium md:block"
          }, _toDisplayString(_ctx.$t("back-to-website")), 9, _hoisted_7),
          _createElementVNode("button", {
            class: "flex items-center p-2 space-x-2 md:hidden",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleMobileMenu) && _unref(toggleMobileMenu)(...args)))
          }, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(isMobileMenuOpen) ? "Close" : "Menu"), 1),
            (!_unref(isMobileMenuOpen))
              ? (_openBlock(), _createElementBlock("img", _hoisted_9))
              : (_openBlock(), _createElementBlock("img", _hoisted_10))
          ])
        ])
      ])
    ])
  ]))
}
}

})